import { render, staticRenderFns } from "./BankId.vue?vue&type=template&id=6ba53ffc"
import script from "./BankId.vue?vue&type=script&lang=js"
export * from "./BankId.vue?vue&type=script&lang=js"
import style0 from "./BankId.vue?vue&type=style&index=0&id=6ba53ffc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports